import React, { useEffect, useRef } from "react";
import { RendererProps } from "./index";
import { Video } from "../../../components/video";

const VideoRenderer: React.FC<RendererProps> = ({ question, onAnswer }) => {
  const firedRef = useRef(false);

  useEffect(() => {
    if (!firedRef.current) {
      firedRef.current = true;
      onAnswer(null, true);
    }
  }, [onAnswer]);

  if (!question.videoSrc) {
    return null;
  }

  return <Video src={question.videoSrc} label={question.description || "video"} />;
};

export default VideoRenderer;
